import React, { useEffect, useRef } from 'react'
import { Link, useForm, usePage } from '@inertiajs/react'

import { Chip, Progress } from '@material-tailwind/react'
import { FaBroom } from 'react-icons/fa6'
import { BsTrash2Fill } from 'react-icons/bs'
import { FaAirFreshener } from 'react-icons/fa'
import { GiPaperBagCrumpled } from 'react-icons/gi'

import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TableFilter from '@/Shared/TableFilter'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import CardContainer from '@/Shared/UI/CardContainer'
import StatsCard from '@/Shared/UI/StatsCard'

import { getItemStatus, getSerNo } from '@/utils'

const Index = () => {
    const {
        consumables,
        totalQuantity,
        consumedQuantity,
        remainingQuantity,
        type,
        auth: {
            user: { role, hospital_id }
        }
    } = usePage().props

    const {
        data,
        meta: { links }
    } = consumables

    const ref = useRef()
    const buttonRef = useRef()

    const {
        data: formData,
        setData,
        post,
        progress,
        reset
    } = useForm({
        file: null,
        type
    })

    useEffect(() => {
        if (formData.file) {
            buttonRef.current.click()
        }
    }, [formData])

    function submit(e) {
        e.preventDefault()
        post(route('consumable-upload'))
        ref.current.value = null
        reset()
    }

    return (
        <div>
            <BreadCrumbs
                link={route().current()}
                title={`${type} Consumable`}
                subTitle="List"
            />

            <h1 className="mb-4 text-3xl font-bold">{type} Consumable</h1>

            {progress && (
                <Progress
                    value={progress.percentage}
                    max="100"
                    color="indigo"
                    className="my-4"
                />
            )}

            <CardContainer>
                <StatsCard
                    title="Brooms (1.5 Kg)"
                    value={`${consumedQuantity[0]}/${totalQuantity[0]}`}
                    icon={FaBroom}
                    link={role === '1' ? route('consumable.detail', 'brooms') : route('consumed.hospital.create', {
                        item: 'brooms',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[0]}
                />

                <StatsCard
                    title="Wiper"
                    value={`${consumedQuantity[1]}/${totalQuantity[1]}`}
                    icon={() => <Icon name="wiper" />}
                    link={role === '1' ? route('consumable.detail', 'wiper') : route('consumed.hospital.create', {
                        item: 'wiper',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[1]}
                />

                <StatsCard
                    title="Normal Waste Bags 21x28 (KG)"
                    value={`${consumedQuantity[2]}/${totalQuantity[2]}`}
                    icon={() => <Icon name="normal_waster_21" />}
                    link={role === '1' ? route('consumable.detail', 'normal_waste_21_bag') : route('consumed.hospital.create', {
                        item: 'normal_waste_21_bag',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[2]}
                />

                <StatsCard
                    title="Normal Waste Bags 30x30 (KG)"
                    value={`${consumedQuantity[3]}/${totalQuantity[3]}`}
                    icon={BsTrash2Fill}
                    link={role === '1' ? route('consumable.detail', 'normal_waste_30_bag') : route('consumed.hospital.create', {
                        item: 'normal_waste_30_bag',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[3]}
                />

                <StatsCard
                    title="Normal Waste Bags 39x45 (KG)"
                    value={`${consumedQuantity[4]}/${totalQuantity[4]}`}
                    icon={GiPaperBagCrumpled}
                    link={role === '1' ? route('consumable.detail', 'normal_waste_39_bag') : route('consumed.hospital.create', {
                        item: 'normal_waste_39_bag',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[4]}
                />

                <StatsCard
                    title="Furniture Dusters"
                    value={`${consumedQuantity[5]}/${totalQuantity[5]}`}
                    icon={() => <Icon name="furniture_duster" />}
                    link={role === '1' ? route('consumable.detail', 'furniture_dusters') : route('consumed.hospital.create', {
                        item: 'furniture_dusters',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[5]}
                />

                <StatsCard
                    title="Disinfectant (2.75 Lit Bottle)"
                    value={`${consumedQuantity[6]}/${totalQuantity[6]}`}
                    icon={() => <Icon name="disinfectant" />}
                    link={role === '1' ? route('consumable.detail', 'disinfectant') : route('consumed.hospital.create', {
                        item: 'disinfectant',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[6]}
                />

                <StatsCard
                    title="Hand Wash Liquid (Liters)"
                    value={`${consumedQuantity[7]}/${totalQuantity[7]}`}
                    icon={() => <Icon name="hand_wash_liquid" />}
                    link={role === '1' ? route('consumable.detail', 'hand_wash_liquid') : route('consumed.hospital.create', {
                        item: 'hand_wash_liquid',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[7]}
                />

                <StatsCard
                    title="Air Freshener (Bottles)"
                    value={`${consumedQuantity[8]}/${totalQuantity[8]}`}
                    icon={FaAirFreshener}
                    link={role === '1' ? route('consumable.detail', 'air_freshener') : route('consumed.hospital.create', {
                        item: 'air_freshener',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[8]}
                />

                <StatsCard
                    title="Mop Pads"
                    value={`${consumedQuantity[9]}/${totalQuantity[9]}`}
                    icon={() => <Icon name="mop_pads" />}
                    link={role === '1' ? route('consumable.detail', 'mop_pads') : route('consumed.hospital.create', {
                        item: 'mop_pads',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[9]}
                />

                <StatsCard
                    title="Liquid Toilet Cleaner (900 ml Bottle)"
                    value={`${consumedQuantity[10]}/${totalQuantity[10]}`}
                    icon={() => <Icon name="liquid_toilet_cleaner" />}
                    link={role === '1' ? route('consumable.detail', 'liquid_toilet_cleaner') : route('consumed.hospital.create', {
                        item: 'liquid_toilet_cleaner',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[10]}
                />

                <StatsCard
                    title="Floor Mops Standard"
                    value={`${consumedQuantity[11]}/${totalQuantity[11]}`}
                    icon={() => <Icon name="floor_mop" />}
                    link={role === '1' ? route('consumable.detail', 'floor_mops_standard') : route('consumed.hospital.create', {
                        item: 'floor_mops_standard',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[11]}
                />

                <StatsCard
                    title="Hand Wash Dispenser"
                    value={`${consumedQuantity[12]}/${totalQuantity[12]}`}
                    icon={() => <Icon name="hand_wash" />}
                    link={role === '1' ? route('consumable.detail', 'hand_wash_dispenser') : route('consumed.hospital.create', {
                        item: 'hand_wash_dispenser',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[12]}
                />

                <StatsCard
                    title="Floor Cleaning Towels"
                    value={`${consumedQuantity[13]}/${totalQuantity[13]}`}
                    icon={() => <Icon name="floor_cleaning_towels" />}
                    link={role === '1' ? route('consumable.detail', 'floor_cleaning_towels') : route('consumed.hospital.create', {
                        item: 'floor_cleaning_towels',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[13]}
                />

                <StatsCard
                    title="Disposable Bed Sheets"
                    value={`${consumedQuantity[14]}/${totalQuantity[14]}`}
                    icon={() => <Icon name="bed_sheets" />}
                    link={role === '1' ? route('consumable.detail', 'disposable_bed_sheets') : route('consumed.hospital.create', {
                        item: 'disposable_bed_sheets',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[14]}
                />

                <StatsCard
                    title="Air Freshener Dispenser (Machines)"
                    value={`${consumedQuantity[15]}/${totalQuantity[15]}`}
                    icon={FaAirFreshener}
                    link={role === '1' ? route('consumable.detail', 'air_freshener_2') : route('consumed.hospital.create', {
                        item: 'air_freshener_2',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[15]}
                />

                <StatsCard
                    title="Air Freshener Dispenser Refills"
                    value={`${consumedQuantity[16]}/${totalQuantity[16]}`}
                    icon={FaAirFreshener}
                    link={role === '1' ? route('consumable.detail', 'air_freshener_3') : route('consumed.hospital.create', {
                        item: 'air_freshener_3',
                        hospital: hospital_id
                    })}
                    remaining={remainingQuantity[16]}
                />
            </CardContainer>

            <div className="mb-6 flex items-center justify-between">
                <div className="flex flex-row items-center gap-x-2">
                    <SearchFilter />

                    {role === '0' && (
                        <div
                            className="relative grid select-none items-center whitespace-nowrap rounded-lg border border-gray-900 py-2 px-4 font-sans text-medium font-bold uppercase text-gray-700">
                            <span className="">Total Supplies Sent: <span
                                className="text-green-500">{data?.length}</span></span>
                        </div>
                    )}

                    {/* {role === '1' && (
                        <IconButton
                            size="lg"
                            color="indigo"
                            className="h-8"
                            onClick={() => ref.current.click()}
                        >
                            <form onSubmit={submit} className="hidden">
                                <input
                                    type="file"
                                    accept=".xls,.xlsx"
                                    name="file"
                                    ref={ref}
                                    onChange={e => setData('file', e.target.files[0])}
                                />

                                <button type="submit" ref={buttonRef}>
                                    Submit
                                </button>
                            </form>

                            <ImFolderUpload size={20} className="cursor-pointer" />
                        </IconButton>
                    )} */}
                </div>

                <div className="flex items-center gap-x-4">
                    {role === '1' && (
                        <TableFilter exportRoute="consumable.export" reportRoute="consumable.report" />
                    )}

                    <Link
                        className="btn-indigo focus:outline-none"
                        href={route('consumable.create', type.toLowerCase())}
                    >
                        <span>Add Consumable</span>
                        <span className="hidden md:inline"> Record</span>
                    </Link>
                </div>
            </div>

            <div className="overflow-x-auto rounded bg-white shadow">
                <table className="w-full whitespace-nowrap">
                    <thead>
                    <tr className="text-left font-bold">
                        <th className="px-6 pb-4 pt-5">Sr No.</th>
                        <th className="px-6 pb-4 pt-5">Hospital</th>
                        <th className="px-6 pb-4 pt-5">District</th>
                        <th className="px-6 pb-4 pt-5">Division</th>
                        <th className="px-6 pb-4 pt-5">Firm</th>
                        <th className="px-6 pb-4 pt-5">Dispatched Date</th>
                        <th className="px-6 pb-4 pt-5">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map(
                        (
                            { id, hospital_name, district, division, firm, item_per, date, deleted_at },
                            index
                        ) => {
                            return (
                                <tr
                                    key={id}
                                    className="focus-within:bg-gray-100 hover:bg-gray-100"
                                >
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {getSerNo(links, index)}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {hospital_name}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {district}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {division}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="flex items-center px-6 py-4 focus:text-indigo-700 focus:outline-none"
                                        >
                                            {firm}
                                            {deleted_at && (
                                                <Icon
                                                    name="trash"
                                                    className="ml-2 h-3 w-3 flex-shrink-0 fill-current text-gray-400"
                                                />
                                            )}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            {date}
                                        </Link>
                                    </td>
                                    <td className="border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="focus:text-indigo flex items-center px-6 py-4 focus:outline-none"
                                        >
                                            <Chip
                                                color={getItemStatus(item_per)}
                                                value={item_per}
                                            />
                                        </Link>
                                    </td>
                                    <td className="w-px border-t">
                                        <Link
                                            tabIndex="-1"
                                            href={route('consumable.item', {
                                                service: String(type).toLowerCase(),
                                                consumable: id
                                            })}
                                            className="flex items-center px-4 focus:outline-none"
                                        >
                                            <Icon
                                                name="cheveron-right"
                                                className="block h-6 w-6 fill-current text-gray-400"
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            )
                        }
                    )}
                    {data.length === 0 && (
                        <tr>
                            <td className="border-t px-6 py-4" colSpan="4">
                                No users found.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
            <Pagination links={links} />
        </div>
    )
}

Index.layout = page =>
    <Layout title="Consumables" children={page} />

export default Index
